export default "/images/dbb753608f860da041b8deeb5a176962.avif";